const BASE_URL = 'https://maps.googleapis.com/maps/api/geocode/json'

const TlGoogleMapsApi = {

  getUserAreaLocation: async ({ userAddress  }) => {
    const params = {
      address : userAddress,
      key     : process.env.REACT_APP_GOOGLE_MAPS_API_KEY
    }

    const url = `${BASE_URL}?address=${encodeURIComponent(params.address)}&key=${encodeURIComponent(params.key)}`

    // still investigating why i got error when using axios on this process, its fine on selldash and shopfront
    return fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .catch((error) => {
        console.error('Error:', error)
      })
  }
}

export default TlGoogleMapsApi
